import React, { Component, Fragment } from "react";

class PaymentSuccess extends Component {
    state = {
        data: [],
        control: null,
        loaded: false,
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.setState({
            control: this.props.control,
            loaded: true,
            data: this.props.data,
        });
    }

    render() {
        if (this.state.loaded) {
            return (
                <>
                    <div className="header">
                        <div className="hold">
                            <a href="/" className="logo"></a>
                        </div>
                    </div>
            <div className="card-updates">
                <div className="payment-response">
                    {this.state.data[0].paymentData.value.result === "OK" ?
                        <>
                            <div className="payment-title">
                                Σας ευχαριστούμε πολύ.
                            </div>
                            <div className="payment-text">
                            Το αίτημά σας καταχωρήθηκε.
                            Θα ενημερωθείτε με SMS για την
                            ενεργοποίηση του πακέτου σας.
                            </div>
                        </>:
                        <>
                            <div className="payment-title">Λυπούμαστε.</div>
                            <div className="payment-text">H πληρωμή σας απέτυχε.</div>
                        </>
                    }
                    <a href="/" className="payment-back">&lt; Επιστροφή</a>
                </div>
            </div>
                </>
            );
        } else {
            return "";
        }
    }
}

export default PaymentSuccess;